/* eslint-disable import/no-default-export */
import { InitialData } from 'src/types';

export default ({ joyride: _removed, ...data }: InitialData) => data;
